export const themeTokens = {
	colorPrimary: "#2457e6",
	colorInfo: "#2457e6",
	colorSuccess: "#16a34a",
	colorWarning: "#f59e0b",
	colorError: "#dc2626",
	colorTextBase: "#111827",
	colorBgLayout: "#f4f6f9",
	colorBorder: "#e5e8ee",
	colorBorderSecondary: "#eef1f5",
	borderRadius: 8,
	fontFamily:
		'"Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
	controlHeight: 36,
};

export const antdTheme = {
	token: themeTokens,
	components: {
		Layout: {
			siderBg: "#0f1b33",
			headerBg: "#0f1b33",
			bodyBg: "#f4f6f9",
			triggerBg: "#0f1b33",
		},
		Menu: {
			darkItemBg: "#0f1b33",
			darkSubMenuItemBg: "#0f1b33",
			darkItemColor: "rgba(255, 255, 255, 0.72)",
			darkItemHoverColor: "#ffffff",
			darkItemSelectedBg: "#2457e6",
			darkItemSelectedColor: "#ffffff",
			itemBorderRadius: 8,
			itemMarginInline: 8,
		},
		Table: {
			headerBg: "#fafbfc",
			headerColor: "#374151",
			rowHoverBg: "#f8fafc",
			borderColor: "#eef1f5",
		},
		Tabs: {
			inkBarColor: "#2457e6",
			itemSelectedColor: "#2457e6",
			itemHoverColor: "#2457e6",
		},
		Segmented: {
			itemSelectedBg: "#ffffff",
			itemSelectedColor: "#111827",
			trackBg: "#eef1f5",
		},
		Card: {
			borderRadiusLG: 12,
			paddingLG: 20,
		},
		Button: {
			borderRadius: 8,
			controlHeight: 36,
		},
		Tag: {
			borderRadiusSM: 6,
		},
		Modal: {
			borderRadiusLG: 12,
		},
	},
};
